<template>
  <v-app>
    <component :is="layout"></component>
    <Toast />
  </v-app>
</template>

<script>
import Toast from '@/components/core/Toast';

export default {
  components: {
    Toast,
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'app'}-layout`;
    },
  },
};
</script>
